export const constant = {
	selector: {
		inputs: 'input[type="date"]',
	},
}
